// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Layout_pageContainer__1cPvS","mainContent":"Layout_mainContent__1bjOp","expandedMainContent":"Layout_expandedMainContent__UZb1s"};